import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "py-4 page-title-center" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "page-title-row" }
const _hoisted_7 = { "aria-label": "breadcrumb" }
const _hoisted_8 = { class: "breadcrumb mt-4" }
const _hoisted_9 = { class: "breadcrumb-item" }
const _hoisted_10 = { class: "breadcrumb-item" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { id: "content" }
const _hoisted_13 = {
  key: 0,
  class: "container"
}
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "topic-post p-4 p-md-5 border-top border-width-5 border-color" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "row justify-content-between align-items-center mb-4" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = {
  class: "mb-0 fw-bold",
  style: {"word-wrap":"break-word"}
}
const _hoisted_20 = { class: "row g-0 justify-content-between align-items-center border-top border-bottom py-3 mb-4" }
const _hoisted_21 = { class: "col-9" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "mb-0 h6 fw-semibold" }
const _hoisted_25 = ["href"]
const _hoisted_26 = { class: "text-muted mb-0 fw-normal" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  class: "d-flex",
  style: {"padding-top":"5px"}
}
const _hoisted_29 = {
  key: 0,
  class: "badge me-2"
}
const _hoisted_30 = { class: "col-auto" }
const _hoisted_31 = {
  class: "dropdown-menu dropdown-menu-links rounded shadow-sm dropdown-menu-end py-0 m-0",
  "aria-labelledby": "editlink2"
}
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "dropdown-item",
  href: "#",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deletePostModal"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "lh-sm small mt-3 op-06" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 0,
  class: "my-2 text-danger"
}
const _hoisted_43 = { id: "content" }
const _hoisted_44 = { class: "mt-3" }
const _hoisted_45 = { class: "container" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "mb-0 fw-bold" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 2,
  class: "my-5 text-center"
}
const _hoisted_52 = { id: "content" }
const _hoisted_53 = { class: "content-wrap" }
const _hoisted_54 = {
  key: 0,
  class: "container mw-md mb-5"
}
const _hoisted_55 = { class: "container mw-md" }
const _hoisted_56 = { class: "container" }
const _hoisted_57 = {
  key: 0,
  class: "row justify-content-center text-center mb-5"
}
const _hoisted_58 = { class: "mw-md mx-auto" }
const _hoisted_59 = {
  key: 0,
  class: "list-unstyled mb-4"
}
const _hoisted_60 = {
  key: 1,
  class: "list-unstyled mb-4"
}
const _hoisted_61 = {
  key: 1,
  class: "forum-content-container",
  role: "main",
  "aria-label": "Community Content"
}
const _hoisted_62 = {
  class: "page-title page-title-parallax parallax scroll-detect py-lg-6 scroll-detect-inview text-pop-image",
  style: {"--cnvs-scroll-height":"395","--cnvs-scroll-percent":"54.493087557603694","--cnvs-scroll-ratio":"1","--cnvs-scroll-start":"1","--cnvs-scroll-end":"0"}
}
const _hoisted_63 = ["src"]
const _hoisted_64 = { class: "container" }
const _hoisted_65 = { class: "page-title-row" }
const _hoisted_66 = { class: "page-title-content mw-xs mx-auto" }
const _hoisted_67 = { class: "h1 mb-3 text-center text-pop-image-text" }
const _hoisted_68 = { class: "color text-larger text-center mt-4 mb-3 text-pop-image-text" }
const _hoisted_69 = { class: "input-group input-group-lg mt-4 mb-4 mw-sm mx-auto" }
const _hoisted_70 = { id: "content" }
const _hoisted_71 = { class: "content-wrap pt-4" }
const _hoisted_72 = { class: "container mw-md" }
const _hoisted_73 = { class: "d-inline-flex w-100 my-2" }
const _hoisted_74 = { class: "d-flex p-0 m-0 w-100 justify-content-between" }
const _hoisted_75 = { class: "forum-home-toolbar" }
const _hoisted_76 = ["selected"]
const _hoisted_77 = ["selected"]
const _hoisted_78 = ["selected"]
const _hoisted_79 = ["selected"]
const _hoisted_80 = ["selected"]
const _hoisted_81 = {
  key: 0,
  class: "forum-home-toolbar"
}
const _hoisted_82 = ["value"]
const _hoisted_83 = {
  key: 1,
  class: "forum-home-toolbar"
}
const _hoisted_84 = ["value"]
const _hoisted_85 = {
  key: 0,
  class: "d-inline-flex w-100 mt-2 mb-4"
}
const _hoisted_86 = {
  key: 0,
  class: "me-2"
}
const _hoisted_87 = ["href"]
const _hoisted_88 = { class: "badge bg-secondary text-white" }
const _hoisted_89 = {
  key: 1,
  class: "me-2"
}
const _hoisted_90 = ["href"]
const _hoisted_91 = { class: "badge bg-secondary text-white" }
const _hoisted_92 = { class: "mw-md mx-auto" }
const _hoisted_93 = {
  key: 0,
  class: "list-unstyled mb-4"
}
const _hoisted_94 = {
  key: 1,
  class: "list-unstyled mb-4"
}
const _hoisted_95 = { class: "pagination justify-content-center" }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = {
  key: 1,
  class: "px-5 py-5"
}
const _hoisted_98 = {
  key: 2,
  class: "my-5 text-center"
}
const _hoisted_99 = {
  class: "modal fade",
  id: "deletePostModal",
  tabindex: "-1",
  "aria-labelledby": "deletePostModalLabel",
  "aria-hidden": "true"
}
const _hoisted_100 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_101 = { class: "modal-content" }
const _hoisted_102 = { class: "modal-body" }
const _hoisted_103 = { class: "row p-4 bg-white d-flex align-items-center justify-content-center rounded" }
const _hoisted_104 = { class: "col-md-12 p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LoadingPost = _resolveComponent("LoadingPost")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_LoadingComment = _resolveComponent("LoadingComment")!
  const _component_PostOutline = _resolveComponent("PostOutline")!
  const _component_LoadingPostOutline = _resolveComponent("LoadingPostOutline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showPostView)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("section", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("nav", _hoisted_7, [
                      _createElementVNode("ol", _hoisted_8, [
                        _createElementVNode("li", _hoisted_9, [
                          _createVNode(_component_router_link, {
                            class: "alt-color",
                            to: "/community/posts"
                          }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createTextVNode(" Community ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", _hoisted_10, [
                          _createElementVNode("a", {
                            class: "alt-color",
                            href: '/community/posts?category=' + _ctx.postDetails?.category
                          }, _toDisplayString(_ctx.postDetails?.category), 9, _hoisted_11)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_12, [
                (_ctx.isLoadPostApiCallInProgress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_LoadingPost)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (!_ctx.isLoadPostApiCallInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("h2", _hoisted_19, _toDisplayString(_ctx.postDetails?.title), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("img", {
                                  alt: "User Thumbnail",
                                  src: _ctx.postDetails?.user?.userThumbnail ? _ctx.assetHost + '/' + _ctx.postDetails?.user?.userThumbnail : '/img/profile_not_found.png',
                                  onerror: "this.onerror=null; this.src='/img/profile_not_found.png'",
                                  class: "rounded-circle me-2",
                                  width: "50",
                                  height: "50",
                                  loading: "lazy",
                                  "aria-label": "User thumbnail"
                                }, null, 8, _hoisted_23),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h5", _hoisted_24, [
                                    _createElementVNode("a", {
                                      class: "text-dark",
                                      href: '/user/' + _ctx.postDetails?.userId
                                    }, _toDisplayString(_ctx.postDetails?.user?.username ?? 'Unknown'), 9, _hoisted_25)
                                  ]),
                                  _createElementVNode("small", _hoisted_26, [
                                    _createTextVNode(_toDisplayString(_ctx.timeSince(Number(_ctx.postDetails?.created))) + " ago ", 1),
                                    (_ctx.postDetails?.edited)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "  (Edited " + _toDisplayString(_ctx.timeSince(Number(_ctx.postDetails?.edited))) + " ago)  ", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postDetails?.user.badges, (badge) => {
                                      return (_openBlock(), _createElementBlock("div", { key: badge }, [
                                        (badge === 'administrator')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [...(_cache[15] || (_cache[15] = [
                                              _createElementVNode("i", { class: "fa-solid fa-user-tie" }, null, -1),
                                              _createTextVNode(" Administrator ", -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _cache[19] || (_cache[19] = _createElementVNode("a", {
                                href: "#",
                                id: "editlink2",
                                "data-bs-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "uil uil-ellipsis-h icon-2x alt-color" })
                              ], -1)),
                              _createElementVNode("div", _hoisted_31, [
                                (_ctx.isOwnPost)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "dropdown-item",
                                      href: '/community/submit?edit=' + _ctx.postDetails?.postId
                                    }, [...(_cache[16] || (_cache[16] = [
                                      _createElementVNode("i", { class: "bi bi-pencil me-1" }, null, -1),
                                      _createTextVNode(" Edit ", -1)
                                    ]))], 8, _hoisted_32))
                                  : _createCommentVNode("", true),
                                (_ctx.isOwnPost)
                                  ? (_openBlock(), _createElementBlock("a", _hoisted_33, [...(_cache[17] || (_cache[17] = [
                                      _createElementVNode("i", { class: "bi bi-trash me-1" }, null, -1),
                                      _createTextVNode(" Delete ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("a", {
                                  class: "dropdown-item",
                                  href: "#",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.flagContent('Post ' + _ctx.postId)))
                                }, [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("i", { class: "bi bi-flag me-1" }, null, -1),
                                  _createTextVNode(" Flag ", -1)
                                ]))])
                              ])
                            ])
                          ]),
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "clear" }, null, -1)),
                          _createElementVNode("div", {
                            class: "rendered-html mb-4",
                            style: {"word-wrap":"break-word"},
                            innerHTML: _ctx.postDetails?.content
                          }, null, 8, _hoisted_34)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["row", { 'd-none': !_ctx.postDetails?.attachments || _ctx.isLoadPostApiCallInProgress }])
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4], (index) => {
                        return _createElementVNode("div", {
                          class: "col-lg-2 col-md-3 col-4 lightbox-preview-row",
                          key: index
                        }, [
                          _createElementVNode("a", {
                            href: _ctx.assetHost + '/' + _ctx.postDetails?.attachments[index],
                            "data-lightbox": "image"
                          }, [
                            ( _ctx.postDetails?.attachments[index] !== undefined)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.assetHost + '/' + _ctx.postDetails?.attachments[index],
                                  alt: "Attachment",
                                  class: "mb-1 rounded-1 lightbox-preview-image",
                                  width: "200",
                                  height: "200",
                                  loading: "lazy",
                                  "aria-label": "Attachment"
                                }, null, 8, _hoisted_36))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_35),
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "d-flex align-items-center justify-content-between px-2" }, null, -1))
                        ])
                      }), 64))
                    ], 2),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.formatNumber(_ctx.postDetails?.views)) + " Views ", 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "button button-small button-border border-color m-0 color h-bg-color h-text-light mt-2 me-2",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.likePost && _ctx.likePost(...args)))
                      }, [
                        _cache[22] || (_cache[22] = _createElementVNode("i", { class: "bi bi-hand-thumbs-up" }, null, -1)),
                        _cache[23] || (_cache[23] = _createTextVNode("Like ", -1)),
                        (_ctx.postLikes.length > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(" + _toDisplayString(_ctx.postLikes.length) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "button button-small button-border border-color m-0 color h-bg-color h-text-light mt-2",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShowEditor(true)))
                      }, [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("i", { class: "bi bi-reply" }, null, -1),
                        _createTextVNode("Reply ", -1)
                      ]))])
                    ]),
                    (_ctx.showEditor)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("form", {
                            onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.createComment()), ["prevent"])),
                            class: "my-4"
                          }, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_TextEditor, {
                                ref: "commentPostTextEditor",
                                enableImage: false
                              }, null, 512),
                              _createElementVNode("button", {
                                type: "submit",
                                disabled: _ctx.isSubmitCommentApiCallInProgress,
                                class: "button button-small m-0 bg-color text-light h-op-08 me-2 mt-2"
                              }, [
                                (_ctx.isSubmitCommentApiCallInProgress)
                                  ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, "Submit"))
                              ], 8, _hoisted_40),
                              _createElementVNode("button", {
                                class: "button button-small button-border border-color m-0 color h-bg-color h-text-light mt-2 me-2",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleShowEditor(false)))
                              }, " Close "),
                              (_ctx.isShowInvalidComment)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, " Comment must be between 5 - 2000 characters. "))
                                : _createCommentVNode("", true)
                            ])
                          ], 32)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("h2", _hoisted_47, [
                        _cache[25] || (_cache[25] = _createTextVNode(" Comments ", -1)),
                        (!_ctx.isLoadPostApiCallInProgress)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "(" + _toDisplayString(_ctx.formatNumber(_ctx.postComments.length)) + ")", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _cache[27] || (_cache[27] = _createElementVNode("hr", { class: "mb-4" }, null, -1)),
                    (!_ctx.isLoadPostApiCallInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentComments, (comment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: comment.commentId
                            }, [
                              _createVNode(_component_Comment, {
                                postComments: _ctx.postComments,
                                postCommentLikes: _ctx.postCommentLikes,
                                postId: _ctx.postId,
                                commentId: comment.commentId,
                                commentLevel: 1,
                                isShowCommentsMode: _ctx.isShowCommentsMode
                              }, null, 8, ["postComments", "postCommentLikes", "postId", "commentId", "isShowCommentsMode"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isLoadPostApiCallInProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (index) => {
                            return _createElementVNode("div", { key: index }, [
                              _createVNode(_component_LoadingComment, { class: "mb-3" })
                            ])
                          }), 64))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadPostApiCallInProgress && _ctx.parentComments.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [...(_cache[26] || (_cache[26] = [
                          _createElementVNode("div", { class: "feature-box fbox-effect flex-column" }, [
                            _createElementVNode("div", { class: "fbox-content" }, [
                              _createElementVNode("h3", null, "No Comments"),
                              _createElementVNode("p", null, "Be the first to share what you think")
                            ])
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  (!_ctx.isLoggedIn)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [...(_cache[28] || (_cache[28] = [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", { class: "signup-box" }, [
                            _createElementVNode("h2", null, "Create an account or sign in to comment"),
                            _createElementVNode("p", null, "You need to be a member in order to leave a comment"),
                            _createElementVNode("button", {
                              class: "signup-btn",
                              onclick: "window.location.href='/signIn';"
                            }, " SIGN UP / LOGIN ")
                          ])
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      (!(!_ctx.isLoadRelatedPostsApiCallInProgress && _ctx.relatedPosts.length == 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [...(_cache[29] || (_cache[29] = [
                            _createElementVNode("div", { class: "col-xl-6 col-lg-8" }, [
                              _createElementVNode("h2", { class: "mb-0 fw-bold" }, " Related Posts ")
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_58, [
                        (!_ctx.isLoadRelatedPostsApiCallInProgress && _ctx.relatedPosts.length > 0)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_59, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedPosts.slice(0, 3), (post) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: post.postId
                                }, [
                                  _createVNode(_component_PostOutline, { post: post }, null, 8, ["post"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isLoadRelatedPostsApiCallInProgress)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_60, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (index) => {
                                return _createElementVNode("li", { key: index }, [
                                  _createVNode(_component_LoadingPostOutline)
                                ])
                              }), 64))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createElementVNode("section", _hoisted_62, [
                _createElementVNode("img", {
                  src: _ctx.appConfigs.assets.communityBannerImage,
                  class: "parallax-bg",
                  alt: "Community Banner",
                  width: "1200",
                  height: "400",
                  loading: "lazy",
                  "aria-label": "Community banner"
                }, null, 8, _hoisted_63),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("h2", _hoisted_67, _toDisplayString(_ctx.appConfigs.general.metadata.communityHome), 1),
                      _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.appConfigs.layout.community.headerCaption), 1),
                      _createElementVNode("form", {
                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.searchCommunity()), ["prevent"])),
                        "aria-label": "Search Community"
                      }, [
                        _createElementVNode("div", _hoisted_69, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control rounded-start border-0 fw-semibold",
                            type: "search",
                            placeholder: "Search...",
                            "aria-label": "Search",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchText) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.searchText]
                          ]),
                          _cache[30] || (_cache[30] = _createElementVNode("button", {
                            class: "btn border-0 bg-white rounded-end h-bg-alt",
                            type: "submit"
                          }, [
                            _createElementVNode("i", { class: "uil uil-search" })
                          ], -1))
                        ])
                      ], 32),
                      _cache[31] || (_cache[31] = _createStaticVNode("<div class=\"text-center\" data-v-ce25dde4><a href=\"/community/submit\" class=\"button border border-width-2 bg-alt py-2 rounded-1 fw-medium text-transform-none ls-0 ms-0 ms-sm-1 h-op-09\" data-v-ce25dde4><i class=\"bi-file-earmark-plus\" data-v-ce25dde4></i>Create Topic </a><a href=\"/community/about\" class=\"button border border-width-2 bg-alt py-2 rounded-1 fw-medium text-transform-none ls-0 ms-0 ms-sm-1 h-op-09\" data-v-ce25dde4><i class=\"bi bi-house\" data-v-ce25dde4></i>About </a></div>", 1))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("ul", _hoisted_74, [
                        _createElementVNode("li", _hoisted_75, [
                          _cache[32] || (_cache[32] = _createElementVNode("label", {
                            for: "topSelect",
                            class: "visually-hidden"
                          }, "Select Sort Option", -1)),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select custom-select-dropdown",
                            id: "topSelect",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sortFilter) = $event)),
                            onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateSortFilter($event.target.value)))
                          }, [
                            _createElementVNode("option", {
                              value: "Latest",
                              selected: _ctx.sortFilter === 'Latest'
                            }, "Latest", 8, _hoisted_76),
                            _createElementVNode("option", {
                              value: "Top (Week)",
                              selected: _ctx.sortFilter === 'Top (Week)'
                            }, "Top (Week)", 8, _hoisted_77),
                            _createElementVNode("option", {
                              value: "Top (Month)",
                              selected: _ctx.sortFilter === 'Top (Month)'
                            }, "Top (Month)", 8, _hoisted_78),
                            _createElementVNode("option", {
                              value: "Top (Year)",
                              selected: _ctx.sortFilter === 'Top (Year)'
                            }, "Top (Year)", 8, _hoisted_79),
                            _createElementVNode("option", {
                              value: "Top (All)",
                              selected: _ctx.sortFilter === 'Top (All)'
                            }, "Top (All)", 8, _hoisted_80)
                          ], 544), [
                            [_vModelSelect, _ctx.sortFilter]
                          ])
                        ]),
                        (_ctx.categoryFilter)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_81, [
                              _cache[33] || (_cache[33] = _createElementVNode("label", {
                                for: "categorySelect",
                                class: "visually-hidden"
                              }, "Select Category", -1)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-select custom-select-dropdown",
                                id: "categorySelect",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.categoryFilter) = $event)),
                                onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateCategoryFilter($event.target.value)))
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appConfigs.layout.community.category, (tag) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: tag.name,
                                    value: tag.name
                                  }, _toDisplayString(tag.name), 9, _hoisted_82))
                                }), 128))
                              ], 544), [
                                [_vModelSelect, _ctx.categoryFilter]
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("li", _hoisted_83, [
                              _cache[35] || (_cache[35] = _createElementVNode("label", {
                                for: "categorySelect",
                                class: "visually-hidden"
                              }, "Select Category", -1)),
                              _createElementVNode("select", {
                                class: "form-select custom-select-dropdown",
                                id: "categorySelect",
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateCategoryFilter($event.target.value)))
                              }, [
                                _cache[34] || (_cache[34] = _createElementVNode("option", {
                                  value: "",
                                  class: "selected hidden disabled"
                                }, "Select Category", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appConfigs.layout.community.category, (tag) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: tag.name,
                                    value: tag.name
                                  }, _toDisplayString(tag.name), 9, _hoisted_84))
                                }), 128))
                              ], 32)
                            ]))
                      ])
                    ]),
                    (_ctx.categoryFilter || _ctx.searchFilter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                          (_ctx.categoryFilter)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_86, [
                                _createElementVNode("a", {
                                  href: _ctx.buildPostQueryString(_ctx.searchFilter, null, _ctx.sortFilter)
                                }, [
                                  _createElementVNode("span", _hoisted_88, [
                                    _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fa-solid fa-tag" }, null, -1)),
                                    _createTextVNode("  " + _toDisplayString(_ctx.categoryFilter) + "   ", 1),
                                    _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-times" }, null, -1))
                                  ])
                                ], 8, _hoisted_87)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.searchFilter)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_89, [
                                _createElementVNode("a", {
                                  href: _ctx.buildPostQueryString(null, _ctx.categoryFilter, _ctx.sortFilter)
                                }, [
                                  _createElementVNode("span", _hoisted_91, [
                                    _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa-solid fa-search" }, null, -1)),
                                    _createTextVNode("  " + _toDisplayString(_ctx.searchFilter) + "   ", 1),
                                    _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-times" }, null, -1))
                                  ])
                                ], 8, _hoisted_90)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_92, [
                      (!_ctx.isInitialLoadApiCallInProgress)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_93, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: post.postId
                              }, [
                                _createVNode(_component_PostOutline, { post: post }, null, 8, ["post"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isInitialLoadApiCallInProgress)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_94, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5], (index) => {
                              return _createElementVNode("li", { key: index }, [
                                _createVNode(_component_LoadingPostOutline)
                              ])
                            }), 64))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_95, [
                        (!_ctx.isLoadMoreApiCallInProgress && !_ctx.isInitialLoadApiCallInProgress && _ctx.currentPosts.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "button button-small button-border border-color m-0 color h-bg-color h-text-light mt-2",
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.loadMorePosts && _ctx.loadMorePosts(...args)))
                              }, " Load More ")
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isLoadMoreApiCallInProgress && !_ctx.isInitialLoadApiCallInProgress)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                              _createVNode(_component_LoadingSpinner, { class: "my-3" })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.isInitialLoadApiCallInProgress && _ctx.posts.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [...(_cache[40] || (_cache[40] = [
                            _createElementVNode("div", { class: "feature-box fbox-effect flex-column" }, [
                              _createElementVNode("div", { class: "fbox-content" }, [
                                _createElementVNode("h3", null, "No Posts"),
                                _createElementVNode("p", null, "Be the first to ask a question!")
                              ])
                            ], -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _cache[44] || (_cache[44] = _createStaticVNode("<div class=\"section bg-transparent my-0 py-0\" data-v-ce25dde4><div class=\"container-fluid py-6\" data-v-ce25dde4><div class=\"row justify-content-center mx-auto mw-md gx-5\" data-v-ce25dde4><div class=\"col\" data-v-ce25dde4><p class=\"h6 mb-0\" data-v-ce25dde4> Opinions expressed on this forum reflect the views of our community and do not constitute professional advice. For further information, please refer to our <a href=\"/community/guidelines\" data-v-ce25dde4>Community Guidelines.</a> Have a quesiton? Need to correct some bad information? Have questions about our community? <a href=\"/about#contact\" data-v-ce25dde4>Contact Us</a></p></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_102, [
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _cache[41] || (_cache[41] = _createElementVNode("h3", { class: "mb-2" }, " Delete Post ", -1)),
                _cache[42] || (_cache[42] = _createElementVNode("p", { class: "mb-4 fw-normal text-smaller text-black-50" }, " Are you sure you want to delete this post? ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "button button-large m-0 bg-color text-light h-op-08",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args))),
                  "data-bs-dismiss": "modal"
                }, "Delete")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}